module.exports = __webpack_public_path__ + "media/images/logo_mv_w-a2253bbbdb5b6f2d9b4a91cf7b947c6c.png";